import pick from 'lodash/pick';
import config from '../../config';
import { types as sdkTypes } from '../../util/sdkLoader';
import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { apiBaseUrl, transactionLineItems } from '../../util/api';
import * as log from '../../util/log';
import { denormalisedResponseEntities } from '../../util/data';
import { findNextBoundary, nextMonthFn, monthIdStringInTimeZone } from '../../util/dates';
import { TRANSITION_ENQUIRE, TRANSITION_ZERO_REQUEST_PAYMENT } from '../../util/transaction';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
} from '../../util/urlHelpers';
import { fetchCurrentUser, fetchCurrentUserHasOrdersSuccess } from '../../ducks/user.duck';
import axios from 'axios';
import { fetchStripeAccount } from '../../ducks/stripeConnectAccount.duck';

const { UUID } = sdkTypes;

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/ListingPage/SET_INITIAL_VALUES';

export const SHOW_LISTING_REQUEST = 'app/ListingPage/SHOW_LISTING_REQUEST';
export const SHOW_LISTING_ERROR = 'app/ListingPage/SHOW_LISTING_ERROR';

export const FETCH_REVIEWS_REQUEST = 'app/ListingPage/FETCH_REVIEWS_REQUEST';
export const FETCH_REVIEWS_SUCCESS = 'app/ListingPage/FETCH_REVIEWS_SUCCESS';
export const FETCH_REVIEWS_ERROR = 'app/ListingPage/FETCH_REVIEWS_ERROR';

export const FETCH_TIME_SLOTS_REQUEST = 'app/ListingPage/FETCH_TIME_SLOTS_REQUEST';
export const FETCH_TIME_SLOTS_SUCCESS = 'app/ListingPage/FETCH_TIME_SLOTS_SUCCESS';
export const FETCH_TIME_SLOTS_ERROR = 'app/ListingPage/FETCH_TIME_SLOTS_ERROR';

export const FETCH_LINE_ITEMS_REQUEST = 'app/ListingPage/FETCH_LINE_ITEMS_REQUEST';
export const FETCH_LINE_ITEMS_SUCCESS = 'app/ListingPage/FETCH_LINE_ITEMS_SUCCESS';
export const FETCH_LINE_ITEMS_ERROR = 'app/ListingPage/FETCH_LINE_ITEMS_ERROR';

export const SEND_ENQUIRY_REQUEST = 'app/ListingPage/SEND_ENQUIRY_REQUEST';
export const SEND_ENQUIRY_SUCCESS = 'app/ListingPage/SEND_ENQUIRY_SUCCESS';
export const SEND_ENQUIRY_ERROR = 'app/ListingPage/SEND_ENQUIRY_ERROR';

export const FETCH_TRANSACTION_ID_REQUEST = 'app/ListingPage/FETCH_TRANSACTION_ID_REQUEST';
export const FETCH_TRANSACTION_ID_SUCCESS = 'app/ListingPage/FETCH_TRANSACTION_ID_SUCCESS';
export const FETCH_TRANSACTION_ID_ERROR = 'app/ListingPage/FETCH_TRANSACTION_ID_ERROR';
export const FETCH_USER_TRANSACTION_ID_SUCCESS =
  'app/ListingPage/FETCH_USER_TRANSACTION_ID_SUCCESS';
export const FETCH_USER_TRANSACTION_ID_REQUEST =
  'app/ListingPage/FETCH_USER_TRANSACTION_ID_REQUEST';

export const ASSIGN_STATUS = 'app/ListingPage/ASSIGN_STATUS';
export const ASSIGN_REQUEST = 'app/ListingPage/ASSIGN_REQUEST';
export const SET_WORKER_BLOCKED_TIMESLOT = 'app/ListingPage/SET_WORKER_BLOCKED_TIMESLOT';

// ================ Reducer ================ //

const initialState = {
  id: null,
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,
  monthlyTimeSlots: {
    // '2019-12': {
    //   timeSlots: [],
    //   fetchTimeSlotsError: null,
    //   fetchTimeSlotsInProgress: null,
    // },
  },
  listingUserTx: null,
  lineItems: null,
  fetchLineItemsInProgress: false,
  fetchLineItemsError: null,
  sendEnquiryInProgress: false,
  sendEnquiryError: null,
  enquiryModalOpenForListingId: null,
  assignedStatus: null,
  fetchTransactionIderror: null,
  listingTransactionId: null,
  applyButtonsReady: false,
  assignButtonsReady: false,
  workerBlockedTimeslots: [],
};

const listingPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };
    case ASSIGN_REQUEST:
      return { ...state, assignButtonsReady: false };
    case ASSIGN_STATUS:
      return { ...state, assignedStatus: payload, assignButtonsReady: true };
    case SHOW_LISTING_REQUEST:
      return { ...state, id: payload.id, showListingError: null };
    case SHOW_LISTING_ERROR:
      return { ...state, showListingError: payload };

    case FETCH_REVIEWS_REQUEST:
      return { ...state, fetchReviewsError: null };
    case FETCH_REVIEWS_SUCCESS:
      return { ...state, reviews: payload };
    case FETCH_REVIEWS_ERROR:
      return { ...state, fetchReviewsError: payload };

    case FETCH_TIME_SLOTS_REQUEST: {
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [payload]: {
          ...state.monthlyTimeSlots[payload],
          fetchTimeSlotsError: null,
          fetchTimeSlotsInProgress: true,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_SUCCESS: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          timeSlots: payload.timeSlots,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_ERROR: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          fetchTimeSlotsError: payload.error,
        },
      };
      return { ...state, monthlyTimeSlots };
    }

    case FETCH_LINE_ITEMS_REQUEST:
      return { ...state, fetchLineItemsInProgress: true, fetchLineItemsError: null };
    case FETCH_LINE_ITEMS_SUCCESS:
      return { ...state, fetchLineItemsInProgress: false, lineItems: payload };
    case FETCH_LINE_ITEMS_ERROR:
      return { ...state, fetchLineItemsInProgress: false, fetchLineItemsError: payload };

    case SEND_ENQUIRY_REQUEST:
      return { ...state, sendEnquiryInProgress: true, sendEnquiryError: null };
    case SEND_ENQUIRY_SUCCESS:
      return { ...state, sendEnquiryInProgress: false };
    case SEND_ENQUIRY_ERROR:
      return { ...state, sendEnquiryInProgress: false, sendEnquiryError: payload };

    case FETCH_TRANSACTION_ID_REQUEST:
      return { ...state, fetchTransactionIderror: null };
    case FETCH_TRANSACTION_ID_SUCCESS:
      return { ...state, listingTransactionId: payload };
    case FETCH_USER_TRANSACTION_ID_REQUEST:
      return { ...state, applyButtonsReady: false };
    case FETCH_USER_TRANSACTION_ID_SUCCESS:
      return { ...state, listingUserTx: payload, applyButtonsReady: true };
    case FETCH_TRANSACTION_ID_ERROR:
      return { ...state, fetchTransactionIderror: payload };

    case SET_WORKER_BLOCKED_TIMESLOT:
      return { ...state, workerBlockedTimeslots: payload };

    default:
      return state;
  }
};

export default listingPageReducer;

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

export const setAssignedStatus = payload => ({
  type: ASSIGN_STATUS,
  payload,
});

export const showListingRequest = id => ({
  type: SHOW_LISTING_REQUEST,
  payload: { id },
});

export const showListingError = e => ({
  type: SHOW_LISTING_ERROR,
  error: true,
  payload: e,
});

export const fetchReviewsRequest = () => ({ type: FETCH_REVIEWS_REQUEST });
export const fetchReviewsSuccess = reviews => ({ type: FETCH_REVIEWS_SUCCESS, payload: reviews });
export const fetchReviewsError = error => ({
  type: FETCH_REVIEWS_ERROR,
  error: true,
  payload: error,
});

export const fetchTimeSlotsRequest = monthId => ({
  type: FETCH_TIME_SLOTS_REQUEST,
  payload: monthId,
});
export const fetchTimeSlotsSuccess = (monthId, timeSlots) => ({
  type: FETCH_TIME_SLOTS_SUCCESS,
  payload: { timeSlots, monthId },
});
export const fetchTimeSlotsError = (monthId, error) => ({
  type: FETCH_TIME_SLOTS_ERROR,
  error: true,
  payload: { monthId, error },
});

export const fetchLineItemsRequest = () => ({ type: FETCH_LINE_ITEMS_REQUEST });
export const fetchLineItemsSuccess = lineItems => ({
  type: FETCH_LINE_ITEMS_SUCCESS,
  payload: lineItems,
});
export const fetchLineItemsError = error => ({
  type: FETCH_LINE_ITEMS_ERROR,
  error: true,
  payload: error,
});

export const sendEnquiryRequest = () => ({ type: SEND_ENQUIRY_REQUEST });
export const sendEnquirySuccess = () => ({ type: SEND_ENQUIRY_SUCCESS });
export const sendEnquiryError = e => ({ type: SEND_ENQUIRY_ERROR, error: true, payload: e });

export const fetchListingTxRequest = () => ({ type: FETCH_TRANSACTION_ID_REQUEST });
export const fetchListingTxSuccess = id => ({
  type: FETCH_TRANSACTION_ID_SUCCESS,
  payload: id,
});
export const fetchListingUserTxSuccess = payload => ({
  type: FETCH_USER_TRANSACTION_ID_SUCCESS,
  payload,
});
export const fetchListingTxError = e => ({
  type: FETCH_TRANSACTION_ID_ERROR,
  error: true,
  payload: e,
});

const setWorkerBlockedTimeslot = payload => ({ type: SET_WORKER_BLOCKED_TIMESLOT, payload });

// ================ Thunks ================ //
const getAssignedStatus = async (workerId, listingId) => {
  const url = `${apiBaseUrl()}/api/user/getAssignedDataByWorkerIdAndListingId`;
  const apiBody = { workerId, listingId };
  const data = await axios.post(url, apiBody);
  const status = data.data.length > 0 ? data.data[0].txLastTransition : ''; //Considering the latest transaction status, in case of reassign
  return status;
};
export const showListing = (listingId, isOwn = false) => async (dispatch, getState, sdk) => {
  dispatch(showListingRequest(listingId));
  // await dispatch(fetchCurrentUser());
  let listingData, authorId;
  const { currentUser } = getState().user;
  const currentUserId = currentUser?.id?.uuid;
  const worker = currentUser;
  const workerId = currentUserId;
  const params = {
    id: listingId,
    include: ['author', 'author.profileImage', 'images'],
    'fields.image': [
      // Listing page
      'variants.default',
      'variants.landscape-crop',
      'variants.landscape-crop2x',
      'variants.landscape-crop4x',
      'variants.landscape-crop6x',

      // Social media
      'variants.facebook',
      'variants.twitter',

      // Image carousel
      'variants.scaled-small',
      'variants.scaled-medium',
      'variants.scaled-large',
      'variants.scaled-xlarge',

      // Avatars
      'variants.square-small',
      'variants.square-small2x',
    ],
  };

  const show = isOwn ? sdk.ownListings.show(params) : sdk.listings.show(params);
  return show
    .then(async data => {
      listingData = data;
      const listing = data.data.data;
      const denoramalisedEntiity = denormalisedResponseEntities(data)[0];
      authorId = denoramalisedEntiity.author.id.uuid;
      const listingId = data.data.data.id.uuid;
      const listingJobCat = data.data?.data?.attributes?.publicData?.searchJobcategory?.[0] || '';
      const listingJobSubCat =
        data.data?.data?.attributes?.publicData?.searchJobsubCategory?.[0] || '';
      const workerJobCat =
        worker?.attributes?.profile?.publicData?.jobCategories
          ?.filter(f => f.isVerified === true)
          ?.map(m => m.category) || [];
      const workerJobSubCat =
        worker?.attributes?.profile?.publicData?.jobCategories
          ?.filter(f => f.isVerified === true)
          ?.map(m => m.subCategory) || [];
      const canFetchAssigned =
        workerJobCat.includes(listingJobCat) &&
        workerJobSubCat.includes(listingJobSubCat) &&
        !!workerId;

      if (canFetchAssigned) {
        const isAssigned = await getAssignedStatus(workerId, listingId);
        dispatch(setAssignedStatus(isAssigned));
      } else {
        dispatch(setAssignedStatus(''));
      }

      if (
        isOwn &&
        ['published', 'closed'].includes(listing.attributes.state) &&
        denoramalisedEntiity.author.id.uuid === currentUserId
      ) {
        const {
          attributes: {
            publicData: { appliedCust = [] },
            privateData: { assigendWorkers = [] },
            metadata: { canceledWorkers = [] },
          },
        } = listing;

        const assigendWorkerSet = new Set(assigendWorkers);
        const filteredAppliedWorkers = appliedCust.filter(worker => !assigendWorkerSet.has(worker));

        const promiseArr = [];
        promiseArr.push(Promise.resolve(listing));
        promiseArr.push(
          axios.post(`${apiBaseUrl()}/api/user/getAwaitingListingData`, {
            listingId: listingId,
          })
        );

        for (let worker of canceledWorkers) {
          promiseArr.push(
            sdk.transactions.query({
              userId: worker,
              listingId,
              include: ['customer', 'customer.profileImage'],
            })
          );
        }

        for (let worker of filteredAppliedWorkers) {
          promiseArr.push(
            sdk.transactions.query({
              userId: worker,
              listingId,
              include: ['customer', 'customer.profileImage'],
            })
          );
        }

        return Promise.all(promiseArr);
      }
      return data;
    })
    .then(async resp => {
      if (isOwn && Array.isArray(resp)) {
        const [listing, assignedWorkersResp, ...rest] = resp;
        const {
          attributes: {
            metadata: { canceledWorkers: cancel = [] },
          },
        } = listing;

        const restApplied = rest.slice(cancel.length);
        const restCanceled = rest.slice(0, cancel.length);
        const appliedWorkers =
          restApplied.length > 0
            ? restApplied.map(worker => denormalisedResponseEntities(worker)[0])
            : [];
        const canceledWorkers =
          restCanceled.length > 0
            ? restCanceled.map(worker => denormalisedResponseEntities(worker)[0])
            : [];
        const stUsers = await Promise.all(
          assignedWorkersResp.data.map(worker =>
            sdk.users.show(
              {
                id: worker.workerId,
                include: ['profileImage'],
                'fields.image': [
                  'variants.default',
                  'variants.square-small',
                  'variants.square-small2x',
                ],
              },
              { expand: true }
            )
          )
        );
        const assignedWorkers = stUsers.map(userResp => denormalisedResponseEntities(userResp)[0]);

        listing.attributes.privateData.assignedWorkers = assignedWorkers;
        listing.attributes.privateData.appliedWorkers = appliedWorkers;
        listing.attributes.privateData.canceledWorkers = canceledWorkers;
      }
      const data = { to: 'business', businessId: authorId };
      return axios.post(`${apiBaseUrl()}/api/reviews/queryReviews`, data);
    })
    .then(resp => {
      const reviews = resp.data;
      listingData.data.data.attributes.reviews = reviews;
      dispatch(addMarketplaceEntities(listingData));
      return 'ok';
    })
    .catch(e => {
      console.log(e);
      dispatch(showListingError(storableError(e)));
    });
};

export const fetchReviews = listingId => (dispatch, getState, sdk) => {
  dispatch(fetchReviewsRequest());
  return sdk.reviews
    .query({
      listing_id: listingId,
      state: 'public',
      include: ['author', 'author.profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    })
    .then(response => {
      const reviews = denormalisedResponseEntities(response);
      dispatch(fetchReviewsSuccess(reviews));
    })
    .catch(e => {
      dispatch(fetchReviewsError(storableError(e)));
    });
};

const timeSlotsRequest = params => (dispatch, getState, sdk) => {
  return sdk.timeslots.query(params).then(response => {
    return denormalisedResponseEntities(response);
  });
};

export const fetchTimeSlots = (listingId, start, end, timeZone) => (dispatch, getState, sdk) => {
  const monthId = monthIdStringInTimeZone(start, timeZone);

  dispatch(fetchTimeSlotsRequest(monthId));

  // The maximum pagination page size for timeSlots is 500
  const extraParams = {
    per_page: 500,
    page: 1,
  };

  return dispatch(timeSlotsRequest({ listingId, start, end, ...extraParams }))
    .then(timeSlots => {
      dispatch(fetchTimeSlotsSuccess(monthId, timeSlots));
    })
    .catch(e => {
      dispatch(fetchTimeSlotsError(monthId, storableError(e)));
    });
};

export const sendEnquiry = (listingId, message) => (dispatch, getState, sdk) => {
  dispatch(sendEnquiryRequest());
  const bodyParams = {
    transition: TRANSITION_ENQUIRE,
    processAlias: config.bookingProcessAlias,
    params: { listingId },
  };
  return sdk.transactions
    .initiate(bodyParams)
    .then(response => {
      const transactionId = response.data.data.id;

      // Send the message to the created transaction
      return sdk.messages.send({ transactionId, content: message }).then(() => {
        dispatch(sendEnquirySuccess());
        dispatch(fetchCurrentUserHasOrdersSuccess(true));
        return transactionId;
      });
    })
    .catch(e => {
      dispatch(sendEnquiryError(storableError(e)));
      throw e;
    });
};

// Helper function for loadData call.
const fetchMonthlyTimeSlots = (dispatch, listing) => {
  const hasWindow = typeof window !== 'undefined';
  const attributes = listing.attributes;
  // Listing could be ownListing entity too, so we just check if attributes key exists
  const hasTimeZone =
    attributes && attributes.availabilityPlan && attributes.availabilityPlan.timezone;

  // Fetch time-zones on client side only.
  if (hasWindow && listing.id && hasTimeZone) {
    const tz = listing.attributes.availabilityPlan.timezone;
    const nextBoundary = findNextBoundary(tz, new Date());

    const nextMonth = nextMonthFn(nextBoundary, tz);
    const nextAfterNextMonth = nextMonthFn(nextMonth, tz);

    return Promise.all([
      dispatch(fetchTimeSlots(listing.id, nextBoundary, nextMonth, tz)),
      dispatch(fetchTimeSlots(listing.id, nextMonth, nextAfterNextMonth, tz)),
    ]);
  }

  // By default return an empty array
  return Promise.all([]);
};

export const fetchTransactionLineItems = ({ bookingData, listingId, isOwnListing }) => dispatch => {
  dispatch(fetchLineItemsRequest());
  transactionLineItems({ bookingData, listingId, isOwnListing })
    .then(response => {
      const lineItems = response.data;
      dispatch(fetchLineItemsSuccess(lineItems));
    })
    .catch(e => {
      dispatch(fetchLineItemsError(storableError(e)));
      log.error(e, 'fetching-line-items-failed', {
        listingId: listingId.uuid,
        bookingData: bookingData,
      });
    });
};
export const fetchTransactionId = listingId => (dispatch, getState, sdk) => {
  dispatch(fetchListingTxRequest());

  return sdk.transactions
    .query({
      only: 'order',
      listingId,
      // lastTransitions: ['transition/request'],
      // lastTransitions: [TRANSITION_ZERO_REQUEST_PAYMENT],
    })
    .then(res => {
      const txId = res?.data?.data?.[0]?.id?.uuid;
      // console.log(85258, res, txId);

      dispatch(fetchListingTxSuccess(txId));
    })
    .catch(e => {
      // console.log(e, 12541);
      dispatch(fetchListingTxError(storableError(e)));
      throw e;
    });
};

export const fetchUserTransaction = listingId => async (dispatch, getState, sdk) => {
  await dispatch(fetchCurrentUser());
  const { currentUser } = getState().user;
  return sdk.transactions
    .query({
      listingId,
      userId: currentUser?.id?.uuid,
      // lastTransitions: ['transition/request'],
      // lastTransitions: [TRANSITION_ZERO_REQUEST_PAYMENT],
    })
    .then(res => {
      const tx = res?.data?.data?.[0] || null;
      dispatch(fetchListingUserTxSuccess(tx));
    })
    .catch(e => {
      // dispatch(fetchListingTxError(storableError(e)));
      throw e;
    });
};

const waitUntillCurrentUserLoaded = (getState, retryInterval = 50) => {
  return new Promise((resolve, reject) => {
    let intervalId = null;
    const checkCurrentUserLoaded = () => {
      const { currentUser } = getState().user;
      const { isAuthenticated } = getState().Auth;

      const isCurrentUserLoaded = isAuthenticated
        ? !!(currentUser && currentUser.id && currentUser.id.uuid)
        : true;
      if (isCurrentUserLoaded) {
        if (intervalId) clearInterval(intervalId);
        resolve(currentUser || null);
      }
    };

    intervalId = setInterval(checkCurrentUserLoaded, retryInterval);
    checkCurrentUserLoaded();
  });
};

const getUserBlockTimeslots = (dispatch, getState) => {
  return waitUntillCurrentUserLoaded(getState, 25)
    .then(currentUser => {
      if (currentUser && currentUser.id && currentUser.id.uuid) {
        return axios.post(`${apiBaseUrl()}/api/timeStatement/getBlockedTimes`, {
          workerId: currentUser.id.uuid,
        });
      }
      return null;
    })
    .then(resp => {
      if (resp && resp.data) {
        dispatch(setWorkerBlockedTimeslot(resp.data));
      }
      return null;
    })
    .catch(err => {
      throw err;
    });
};

export const loadData = (params, search) => (dispatch, getState) => {
  dispatch({ type: ASSIGN_REQUEST });
  dispatch({ type: FETCH_USER_TRANSACTION_ID_REQUEST });
  const listingId = new UUID(params.id);

  const ownListingVariants = [LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT];
  if (ownListingVariants.includes(params.variant)) {
    return dispatch(showListing(listingId, true));
  }

  const checkAndShowOwnListing = () => {
    return waitUntillCurrentUserLoaded(getState, 25).then(currentUser => {
      const isOwnListing = !!currentUser?.attributes?.profile?.publicData?.isProvider;
      return dispatch(showListing(listingId, isOwnListing));
    });
  };

  return Promise.all([
    checkAndShowOwnListing(),
    dispatch(fetchReviews(listingId)),
    dispatch(fetchUserTransaction(listingId)),
    getUserBlockTimeslots(dispatch, getState),
  ]).then(responses => {
    if (responses[0] && responses[0].data && responses[0].data.data) {
      const listing = responses[0].data.data;
      const currentUser = getState().user.currentUser;
      if (currentUser && currentUser.stripeAccount) {
        dispatch(fetchStripeAccount());
      }

      // Fetch timeSlots.
      // This can happen parallel to loadData.
      // We are not interested to return them from loadData call.
      fetchMonthlyTimeSlots(dispatch, listing);
    }

    return responses;
  });
};
